import api from './client.js'

export const profileItemsAPI = {
  list:        ()             => api.get('/profile-items'),
  mine:        ()             => api.get('/profile-items/mine'),
  ofUser:      (userId)       => api.get(`/profile-items/user/${userId}`),
  create:      (data)         => api.post('/profile-items', data),
  update:      (id, data)     => api.patch(`/profile-items/${id}`, data),
  remove:      (id)           => api.delete(`/profile-items/${id}`),
  grant:       (id, userId, source) => api.post(`/profile-items/${id}/grant`, { user_id: userId, source }),
  revoke:      (id, userId)   => api.post(`/profile-items/${id}/revoke`, { user_id: userId }),
  equip:       (slot, itemId) => api.put('/profile-items/equip', { slot, item_id: itemId ?? null }),
  ofTeam:      (teamId)       => api.get(`/profile-items/team/${teamId}`),
  equipTeam:   (teamId, slot, itemId) => api.put('/profile-items/team/equip', { team_id: teamId, slot, item_id: itemId ?? null }),
  grantTeam:   (id, teamId, source) => api.post(`/profile-items/${id}/grant-team`, { team_id: teamId, source }),
  revokeTeam:  (id, teamId)   => api.post(`/profile-items/${id}/revoke-team`, { team_id: teamId }),
  uploadImage: (formData) => api.post('/profile-items/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  holders:     (id) => api.get(`/profile-items/${id}/holders`),
}
